/** The Organisation section's parts, one per tab; the members tab holds the pending invitations too. */
export const ORG_TABS = ["members", "spaces", "groups", "support", "feed", "settings"] as const;
export type OrgTab = (typeof ORG_TABS)[number];

export function parseOrgTab(s: Record<string, unknown>): { tab?: OrgTab } {
  return ORG_TABS.includes(s.tab as OrgTab) && s.tab !== "members" ? { tab: s.tab as OrgTab } : {};
}
